import mycv from '../assets/pdf/mycv.pdf'
import pixxx from '../assets/jpg/pixxxx.jpg'
import pic from '../assets/jpg/cv pic.jpg'

export const headerData = {
    name: 'Software Developer',
    title: "Akshitha Chinthakindi",
    desciption:"I am an undergraduate pursuing my Bachelors in Computer Science & Technology. I am an enthusiastic learner with creative insights and I never shy away from trying out new things and implementing them. I enjoy solving puzzles and taking part in coding competitions. My interests Software Development and I also enjoy participating in Hackathons and coding challenges. ",
    // image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: pic,
    resumePdf: mycv
}
